/** Classificações das cidades e suas sub-regiões e bairros */
export interface CidadeClassificacaoAbc {
    id: number,
    nome: string;
}

export const cidadeClassificacaoA: CidadeClassificacaoAbc = {id: 1, nome: 'A'};
export const cidadeClassificacaoB: CidadeClassificacaoAbc = {id: 2, nome: 'B'};
export const cidadeClassificacaoC: CidadeClassificacaoAbc = {id: 3, nome: 'C'};
export const cidadeClassificacaoX: CidadeClassificacaoAbc = {id: 4, nome: 'X'};

export const cidadeClassificacoes: CidadeClassificacaoAbc[] = [
    cidadeClassificacaoA,
    cidadeClassificacaoB,
    cidadeClassificacaoC,
    cidadeClassificacaoX
];
